import React, { useMemo } from 'react';
import { analyticsSnapshot } from '../../data/analyticsSnapshot';
import MetricSummary from '../common/MetricSummary';
import { findLatestValue } from '../../utils/dataHelpers';
import ChartCard from '../common/ChartCard';
import { ChartData } from 'chart.js';

const WebPagesPage: React.FC = () => {
  const pages = analyticsSnapshot.webAnalytics.pages;
  const latestOrganic = findLatestValue(pages.datasets[0].data);
  const latestPaid = findLatestValue(pages.datasets[1].data);
  const label = latestOrganic.index >= 0 ? pages.labels[latestOrganic.index] : 'Veri yok';
  const insights = analyticsSnapshot.aiAnalysis.webAnalytics.pages.insights;

  const chartData = useMemo<ChartData<'bar'>>(
    () => ({
      labels: Array.from(pages.labels),
      datasets: [
        {
          label: 'Organik',
          data: Array.from(pages.datasets[0].data)
        },
        {
          label: 'Ücretli',
          data: Array.from(pages.datasets[1].data)
        }
      ]
    }),
    [pages.labels, pages.datasets]
  );

  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-white">Sayfa Ziyaretleri</h1>
          <p className="text-white/70 mt-2">
            Organik ve ücretli arama kaynaklı sayfa görüntülemelerini analiz ederek içerik stratejisini planlayın.
          </p>
        </div>
        <div className="text-sm text-white/40">
          Son veri: <span className="text-white/70">{label}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <MetricSummary
          title="Organik Arama Ziyaretleri"
          value={latestOrganic.value}
          description="Organik arama sonuçlarından gelen sayfa ziyaretleri."
        />
        <MetricSummary
          title="Ücretli Arama Ziyaretleri"
          value={latestPaid.value}
          description="Ücretli arama kampanyaları ile gelen sayfa ziyaretleri."
        />
      </div>

      <ChartCard
        title="Aylık Sayfa Görüntüleme Trendleri"
        description="Organik ve ücretli arama kaynaklı sayfa görüntülemeleri."
        chartType="bar"
        data={chartData}
        insights={insights}
      />

    </div>
  );
};

export default WebPagesPage;

